import Domain from "./domain";
export default {
  methods: {
    loginCompany: async function(port, token) {
      let url = `${Domain.RAW_DOMAIN +
        "/" +
        port}/api/v1/customer/auth/portal/login?token=Bearer ${token}`;

      try {
        let response = await this.axios.get(url);
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    grantedModules: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "customer/profile/available/models/" + id,
          Domain.APP_HEADER
        );
        return response;
      } catch (error) {
        throw error;
      }
    },
    authLogin: async function(obj) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/auth/login",
          obj,
          Domain.APP_HEADER
        );
        return response;
      } catch (error) {
        throw error;
      }
    },
    authCompanyLogin: async function(obj) {
      try {
        let response = await this.axios.post(
          Domain.MAIN_DOMAIN + "api/master/company/login",
          obj,
          Domain.APP_HEADER
        );
        return response;
      } catch (error) {
        throw error;
      }
    }
  }
};
